// RouteTracker.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const RouteTracker = ({ isAuthenticated }) => {
  const location = useLocation();

  useEffect(() => {
    console.log('isAuthenticated:', isAuthenticated);
    // Send an API request to your server to save the visited route in the database
    // fetch('/api/track-visit', {
    //   method: 'POST',
    //   headers: {
    //     'Content-Type': 'application/json',
    //   },
    //   body: JSON.stringify({ route: location.pathname }),
    // });
    console.log("location.pathname",location.pathname);
  }, [location.pathname]);

  return null; // This component doesn't render anything to the UI
};

export default RouteTracker;
